import React from 'react';

import { BottomActionBar } from '@/components/composed';
import { Button, Text } from '@/design-system/components/ui';

import { AffiliateApplicationStatus } from '../domain/affiliate-application-types';

interface Props {
  selectedCount: number;
  selectedStatus: AffiliateApplicationStatus | null;
  onApprove: () => void;
  onReject: () => void;
  onHold: () => void;
  onUpdateAdminNotes: () => void;
  isLoading?: boolean;
}

export const AffiliateApplicationsBottomBar = ({
  selectedCount,
  selectedStatus,
  onApprove,
  onReject,
  onHold,
  onUpdateAdminNotes,
  isLoading,
}: Props) => {
  if (selectedCount === 0) {
    return null;
  }

  const renderActions = () => {
    switch (selectedStatus) {
      case AffiliateApplicationStatus.Pending:
        return (
          <>
            <Button size="sm" variant="outline" onClick={onHold} disabled={isLoading}>
              Hold
            </Button>
            <Button size="sm" variant="destructive" onClick={onReject} disabled={isLoading}>
              Reject
            </Button>
            <Button size="sm" variant="primary" onClick={onApprove} disabled={isLoading}>
              Approve
            </Button>
          </>
        );
      case AffiliateApplicationStatus.Approved:
      case AffiliateApplicationStatus.Rejected:
        return (
          <Button size="sm" variant="primary" onClick={onUpdateAdminNotes} disabled={isLoading}>
            Update admin notes
          </Button>
        );
      case AffiliateApplicationStatus.OnHold:
        return (
          <>
            <Button size="sm" variant="outline" onClick={onUpdateAdminNotes} disabled={isLoading}>
              Update admin notes
            </Button>
            <Button size="sm" variant="destructive" onClick={onReject} disabled={isLoading}>
              Reject
            </Button>
            <Button size="sm" variant="primary" onClick={onApprove} disabled={isLoading}>
              Approve
            </Button>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <BottomActionBar>
      <div className="tw:flex tw:flex-row tw:gap-4 tw:items-center tw:justify-between">
        <Text variant="body-md">
          Selected: <strong>{selectedCount}</strong>
        </Text>
        <div className="tw:flex tw:flex-row tw:gap-4 tw:items-center">{renderActions()}</div>
      </div>
    </BottomActionBar>
  );
};
